import { render, staticRenderFns } from "./goodsManagementList.vue?vue&type=template&id=2044d2a3&scoped=true&"
import script from "./goodsManagementList.vue?vue&type=script&lang=js&"
export * from "./goodsManagementList.vue?vue&type=script&lang=js&"
import style0 from "./goodsManagementList.vue?vue&type=style&index=0&id=2044d2a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044d2a3",
  null
  
)

export default component.exports